import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {Scan3dGroupModel} from '../../../api/entity/scan3dGroup.model';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';

@Injectable()
export class Scan3dGroupRepository extends AbstractRepositoryV2<Scan3dGroupModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Scan3dGroup', serviceElementsFactory, injector);
    }
}
